
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { css } from 'aphrodite';

import { OverlayView } from 'react-google-maps';

import styles from './styles.js';

function getMarkerPixelPositionOffset() {
    return { x: -25, y: -38 };
}

class MapMarker extends Component {
    static propTypes = {
        currencySymbol: PropTypes.string.isRequired,
        handleMarkerClick: PropTypes.func.isRequired,
        hoveredRoomId: PropTypes.number,
        lastHoveredRoomId: PropTypes.number,
        marker: PropTypes.object.isRequired
    }

    shouldComponentUpdate(nextProps) {
        const { marker } = this.props;
        if (Number(nextProps.hoveredRoomId) === Number(marker.id)) {
            return true;
        }
        if ((Number(nextProps.hoveredRoomId) !== Number(marker.id)) &&
        (Number(nextProps.lastHoveredRoomId) === Number(marker.id))) {
            return true;
        }
        return false;
    }

    handleMarkerClick = () => {
        const { handleMarkerClick, marker } = this.props;
        handleMarkerClick(marker);
    }

    render() {
        const { handleMarkerClick } = this;
        const { currencySymbol, hoveredRoomId, marker } = this.props;
        return (
            <OverlayView
                {...marker}
                roomId={marker.id}
                position={{ lat: marker.position.lat, lng: marker.position.lng }}
                getPixelPositionOffset={getMarkerPixelPositionOffset}
                mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
            >
                <div
                    onClick={handleMarkerClick}
                    className={
                        Number(hoveredRoomId) === Number(marker.id) ?
                            css(styles.overlayViewHighlighted) :
                            css(styles.overlayView)
                    }
                >
                    <span className={css(styles.priceText)}>
                        {
                            marker.price ?
                                <span>
                                    <span dangerouslySetInnerHTML={{ __html: currencySymbol }} />{
                                        Number(marker.price) < 100 ? Number(marker.price).toFixed(2) : Number(marker.price)
                                    }
                                </span> : '-'
                        }</span>
                    <svg className={css(styles.fang)}>
                        <path
                            d="M0,10 20,10 10,0z"
                            className={
                                Number(hoveredRoomId) === Number(marker.id) ?
                                    css(styles.fangShapeHovered) :
                                    css(styles.fangShape)
                            }
                        />
                        <path
                            d="M0,10 10,0 20,10"
                            className={css(styles.fangStroke)}
                        />
                    </svg>
                </div>
            </OverlayView>
        );
    }
}

const mapStateToProps = state => ({
    currencySymbol: state.searchObject.currency_symbol_left,
    hoveredRoomId: state.hoveredRoomId,
    lastHoveredRoomId: state.lastHoveredRoomId
});

export default connect(mapStateToProps)(MapMarker);



// WEBPACK FOOTER //
// ./src/pages/Search/Main/MapSection/GoogleMap/MapMarker.jsx